import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

// KAN-1342: UI-состояние чата, общее для страницы /chat и портал-виджета: какая беседа открыта
// и кто сейчас печатает. Серверных данных здесь нет — они в React Query.

export interface TypingInfo {
  userId: string;
  displayName: string;
}

interface ChatSelectionState {
  selectedConversationId: string | null;
  typing: Record<string, TypingInfo>;
  selectConversation: (id: string | null) => void;
  setTyping: (conversationId: string, info: TypingInfo | null) => void;
}

// KAN-1555: открытая беседа переживает перезагрузку вкладки (sessionStorage — только эта вкладка): Chrome выгружает
// свёрнутую вкладку из памяти и при возврате грузит заново — раньше вместо беседы открывался список.
export const useChatSelectionStore = create<ChatSelectionState>()(
  persist(
    (set) => ({
      selectedConversationId: null,
      typing: {},
      selectConversation: (id) =>
        set((s) =>
          s.selectedConversationId === id ? s : { selectedConversationId: id },
        ),
      setTyping: (conversationId, info) =>
        set((s) => {
          const cur = s.typing[conversationId];
          if (!info) {
            if (!cur) return s;
            const next = { ...s.typing };
            delete next[conversationId];
            return { typing: next };
          }
          if (
            cur &&
            cur.userId === info.userId &&
            cur.displayName === info.displayName
          )
            return s;
          return { typing: { ...s.typing, [conversationId]: info } };
        }),
    }),
    {
      name: "gl-chat-selected",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (s) => ({ selectedConversationId: s.selectedConversationId }),
    },
  ),
);
